import { render, staticRenderFns } from "./index.vue?vue&type=template&id=78c24fcb&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78c24fcb')) {
      api.createRecord('78c24fcb', component.options)
    } else {
      api.reload('78c24fcb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=78c24fcb&", function () {
      api.rerender('78c24fcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/upgrade/index.vue"
export default component.exports